/*
 * @note 极验人机校验接口封装 - 调获取验证码接口时的人机验证
 * @param currentAccount {String} 当前登录账号
 *        tsignDataTrackName {String} 埋点号
 *
 *
 *        countDownDisabled {Boolean} 外部按钮控制器
 * @auth yunfan
 * @create 20201201
 */
export default {
  methods: {
    geeManMachineCheck(currentAccount = '') {
      return new Promise((resolve, reject) => {
        this.$axios({
          baseURL: this.BASE_URL,
          url: 'sender/robotAuth/apply/v3',
          method: 'POST',
          data: {
            principal: currentAccount, // 当前手机号或者邮箱，即当前登录账号
            /* eslint-disable-next-line */
            client_type: 'web',
          },
        })
          .then(res => {
            const { data } = res

            // 如果data为null
            if (data === null) {
              return {}
            }

            /* eslint-disable-next-line */
            return initGeetest(
              {
                product: 'bind', // 隐藏按钮式
                gt: data.gt,
                challenge: data.challenge,
                offline: !data.success,
                /* eslint-disable-next-line */
                new_captcha: data.new_captcha,
              },
              captchaObj => {
                // captchaObj.appendTo('#captcha-box')
                captchaObj
                  .onReady(() => {
                    // 验证码ready之后才能调用verify方法显示验证码
                    captchaObj.verify()
                  })
                  .onSuccess(() => {
                    const result = captchaObj.getValidate()

                    // @params [Object] result 包含三个参数 geetest_challenge  geetest_validate  geetest_seccode
                    resolve(result)
                  })
                  .onClose(() => {
                    // 外部函数，重复点击变量
                    this.countDownDisabled = false
                  })
                  .onError(err => {
                    this.$message.error('获取验证码失败')
                    this.countDownDisabled = false
                  })
              }
            )
          })
          .catch(err => {
            // this.$message.error(err.message)
            console.error(err)
            this.countDownDisabled = false

            // eslint-disable-next-line prefer-promise-reject-errors
            reject(false)
          })
      })
    },
  },
}
